import React from 'react'
import dayjs from '../../../../dayjsConfig'
import { darkBlue, darkerGreen, darkGreen, primaryBlue } from '../../../../styles/material-ui-theme-v2'
import makeStyles from '@material-ui/core/styles/makeStyles'

export interface ConsistencyProgress {
  date: string
  achieved: boolean
}

export interface IYumConsistencyPillsProps {
  progress: ConsistencyProgress[]
  darkBg?: boolean
  /** When false, past days show as neutral (white/current) instead of met/unmet */
  isParticipating?: boolean
}

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginTop: '10px',

    /*gap: '4px',
    '@media (min-width: 375px)': {
      gap: '5px',
    },
    [theme.breakpoints.up('sm')]: {
      //'@include respond-above(sm)': {
      gap: '6px',
    },*/

    overflowX: 'scroll',
    overflowY: 'visible',

    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  day: {
    width: '100%',
    height: '6px',
    backgroundColor: primaryBlue,
    opacity: 0.1,
    borderRadius: '10px',
    flexBasis: '100%',
    minWidth: '4px',
    marginRight: '4px',
    '@media (min-width: 375px)': {
      minWidth: '5px',
      marginRight: '5px',
    },
    [theme.breakpoints.up('sm')]: {
      minWidth: '6px',
      marginRight: '6px',
    },
    'html[dir=ltr] &:last-child': {
      marginRight: '0px !important',
    },
    'html[dir=rtl] &:first-child': {
      marginRight: '0px !important',
    },
  },
  unmet: {
    height: '24px',
    backgroundColor: darkBlue,
    opacity: 0.2,
  },
  current: {
    height: '24px',
    //backgroundColor: primaryBlue,
    opacity: 1,
  },
  met: {
    height: '24px',
    backgroundColor: darkGreen,
    opacity: 1,

    '&$current': {
      backgroundColor: darkerGreen,
    },
  },
}))

export default function YumConsistencyPills(props: IYumConsistencyPillsProps) {
  const classes = useStyles()

  const dayBEM = ({ date, achieved }: ConsistencyProgress) => {
    const base = classes.day
    const classArray = [base]
    const isToday = dayjs().locale('en').format('YYYY-MM-DD') === date
    const isPast = dayjs(date).isBefore(new Date())

    if (isToday || isPast) {
      classArray.push(achieved ? classes.met : classes.unmet)
    }

    if (isToday) {
      classArray.push(classes.current)
    }

    return classArray.join(' ')
  }

  return (
    <div className={classes.wrapper}>
      {props.progress.map((day: ConsistencyProgress, keyIndex) => {
        return <div title={day.date} className={dayBEM(day)} key={keyIndex} />
      })}
    </div>
  )
}
